import React, { memo } from 'react';
import {Placeholder} from 'react-bootstrap';

const PlaceholderCard = memo(() => (
    <div className="product-pro cart">
        <div className="product-img-top">
            <Placeholder animation="glow">
                <Placeholder xs={12} />
            </Placeholder>
        </div>
        <div className="card-body text-center mt-4">
            <Placeholder animation="glow">
                <Placeholder as="h1" xs={4} />
            </Placeholder>
            <div className="product-price">
                <Placeholder animation="glow">
                    <Placeholder xs={4} />
                </Placeholder>
            </div>
            <Placeholder animation="glow">
                <Placeholder.Button className="btn add-to-cart mt-4" />
            </Placeholder>
        </div>
    </div>
));
export default PlaceholderCard;